export const roundPercentage = (percentage: number) => {
  return Math.round(percentage);
};

export const leadingZero = (value: number) => {
  return String(value).padStart(2, '0');
};
